"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CarouselNav: function() {
        return _index.CarouselNav;
    },
    carouselNavClassNames: function() {
        return _index.carouselNavClassNames;
    },
    renderCarouselNav_unstable: function() {
        return _index.renderCarouselNav_unstable;
    },
    useCarouselNavStyles_unstable: function() {
        return _index.useCarouselNavStyles_unstable;
    },
    useCarouselNav_unstable: function() {
        return _index.useCarouselNav_unstable;
    }
});
const _index = require("./components/CarouselNav/index");
